export type FaqItem = {
  category: string;
  question: string;
  answer: string;
};

export const faqCategories = ["全部", "提交相关", "匿名与安全", "材料与核实", "后续跟进"];

export const faqList: FaqItem[] = [
  {
    category: "提交相关",
    question: "提交线索之后，多久会有人回应我？",
    answer:
      "绝大多数线索会在 72 小时内得到首次回应。涉及公共安全、正在发生的侵害等高优先线索，我们通常会当天处理。如果超过一周没有收到任何回应，可能是你的联系方式填写有误，或是线索尚不具备可核实的事实要素。",
  },
  {
    category: "提交相关",
    question: "我只有一段模糊的听闻，没有任何文件，可以投吗？",
    answer:
      "可以投，但请如实说明这属于听闻而非亲历。传闻本身不能作为报道依据，但它可以帮助我们判断该往哪个方向去寻找证据。请尽量写清楚消息来源与消息来源的可靠性，以及你能接触到的其他材料。",
  },
  {
    category: "提交相关",
    question: "可以只留联系方式，先聊聊再决定要不要给材料吗？",
    answer:
      "完全可以，而且我们更推荐这样做。很多提供者会先用一个可丢弃的联系方式与我们建立信任，确认对方身份与处理方式后，再决定交出多少材料。你不必在第一次接触时就交出全部内容。",
  },
  {
    category: "匿名与安全",
    question: "你们会记录我的 IP 或设备信息吗？",
    answer:
      "站内提交通道不做 IP 留痕，提交内容与你的网络身份分开存储。但我们仍建议你使用不绑定真实身份的邮箱、并在不连接公司网络的设备上操作，因为通信运营商与单位网络层面仍可能留存记录，这不是我们单方面能控制的。",
  },
  {
    category: "匿名与安全",
    question: "如果材料里有我的名字，会不会被看出来？",
    answer:
      "在呈现之前，我们会做系统性的脱敏处理：删除文件属性中的作者信息、对可识别字段打码、调整过于具体的岗位与时间描述。也会在发布前把最终版本给你过目，由你确认是否还有识别风险。",
  },
  {
    category: "匿名与安全",
    question: "单位要求我不能外传材料，我还应该投吗？",
    answer:
      "这取决于你所在地的法律与你所签署的协议，我们无法替你判断，也不能替代法律意见。如果线索涉及重大公共利益，我们建议你先咨询专业人士。你的安全永远优先于一条线索，我们不鼓励任何可能让你承担不可控风险的行为。",
  },
  {
    category: "材料与核实",
    question: "什么样的材料最有可能被采信？",
    answer:
      "原始文件优于二次转述，完整链路优于单点截图，能说明获取方式的材料优于匿名转发。我们会优先采信可交叉验证、有明确时间与来源指向、并且能与公开信息互相印证的材料。",
  },
  {
    category: "材料与核实",
    question: "截图可以吗？会不会被判定为伪造？",
    answer:
      "截图有价值，但单独一张截图往往不足以支撑报道。请尽量提供原始载体，比如邮件原件、系统导出记录或聊天记录的原设备，并说明截图之外还有哪些可以佐证的材料。我们不会仅凭截图公开报道。",
  },
  {
    category: "材料与核实",
    question: "提交之后，我可以知道核实进展吗？",
    answer:
      "可以。线索进入核实阶段后，我们会告知你当前处于哪一步、还需要补充什么。如果你希望全程不被打扰，也可以选择一次性提交、不接受回访，我们会尊重这个选择。",
  },
  {
    category: "后续跟进",
    question: "你们会不会公开我的身份来增强可信度？",
    answer:
      "不会。除非你明确书面同意，我们不会公开任何可指向你的信息。在必须引用当事人陈述时，我们会使用代号并模糊化岗位与地区描述。可信度来自材料本身的交叉验证，而不是牺牲你的身份。",
  },
  {
    category: "后续跟进",
    question: "如果线索最终没有被采用，材料会怎么处理？",
    answer:
      "未被采用的线索原件会在约定保留期结束后清除，仅保留不含个人信息的处理记录。如果你在提交时要求立即删除，我们会在核实结论形成后按你的要求执行，并回复确认。",
  },
  {
    category: "后续跟进",
    question: "同一件事我想补充新材料，需要重新提交吗？",
    answer:
      "不需要。你在首次提交时留下的联系方式就是我们找回你的唯一凭据。补充材料时，请在内容中说明与哪一条线索相关，或直接注明你的提交代号，我们会把它并入原有的核实流程。",
  },
];